if (!customElements.get('component-tabs')) {
    customElements.define(
        'component-tabs',
        class ComponentTabs extends HTMLElement {
            constructor() {
                super();

                this.navigationLinks = this.querySelectorAll('.tabs-navigation .tabs__link')
                this.content = this.querySelector('.tabs-content')
            }

            connectedCallback() {
                this.navigationLinks.forEach(tab => {
                    tab.addEventListener('click', this.tabClickHandler);
                });
            }

            disconnectedCallback() {
                this.navigationLinks.forEach(tab => {
                    tab.removeEventListener('click', this.tabClickHandler);
                });
            }

            tabClickHandler = (event) => {
                const clickedTab = event.target.closest('.tabs__link');
                if (!clickedTab) return;

                this.navigationLinks.forEach(link => link.classList.remove('active'))
                clickedTab.classList.add('active');

                const tabContainer = this.content.querySelector(`[data-tab-container="${clickedTab.dataset.index}"]`);
                if (tabContainer) {
                    this.content.querySelectorAll('.tabs__container').forEach(container => container.classList.remove('visible'));
                    tabContainer.classList.add('visible');
                }
            };
        }
    );
}